/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Twowayvalve2Inputs */



/**
* | output |
* | --- |
* | "2-way valve" |
*
* @param {Ahu_History_Key_Twowayvalve2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_twowayvalve2 = /** @type {((inputs?: Ahu_History_Key_Twowayvalve2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Twowayvalve2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("2-way valve")
	return /** @type {LocalizedString} */ ("Vanne 2 voies")
});
export { ahu_history_key_twowayvalve2 as "ahu_history_key_twoWayValve" }